import React from 'react';
import { Radio, RadioGroup, FormControlLabel, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

import useTranslateText from '../use_translate_text';

const InputRadio = (props) => {
  const CustomRadio = withStyles({
    root: {
      color: '#81a7bb',
      '&$checked': {
        color: '#EB9937',
      },
    },
    checked: {},
  })((props) => <Radio color="default" {...props} />);

  const { className, data, name, onChange, value, displayFlex } = props,
        { translateText } = useTranslateText(),
        classNames = `input-radio ${className} ${displayFlex ? '' : 'd-block'}`;

  return (
    <RadioGroup
      aria-label={name}
      className={classNames}
      name={name}
      onChange={e => onChange(e.target.value)}
    >
      {data.map((item, i) => {
        const isChecked = value === item.value;
        return (
          <FormControlLabel
            key={i}
            value={item.value}
            control={
              <CustomRadio
                checked={isChecked}
                value={item.value}
                name="radio-button-demo"
                inputProps={{ 'aria-label': 'C' }}
              />
            }
            label={translateText(item.label)}
          />
        );
      })}
    </RadioGroup>
  );
};

export default InputRadio;

InputRadio.propTypes = {
  name: PropTypes.string.isRequired,
  data: PropTypes.bool.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

/* ---------------Example----------------
  const data = [
        {
          value: 'yes',
          label: 'Yes',
        },
        {
          value: 'no',
          label: 'No',
        },
      ],
      value: 'yes',   // value should be match to the value of any item in data;
      onChange = (newValue) => {
        setState('value', newValue);
      },
      name = 'radio-group-name',
      className = 'radio-group__classname';

  <InputRadio
    className={className}
    data={data},
    onChange={onChange},
    value={value},
  />
*/